import PropTypes from 'prop-types';
import { values } from 'rambdax';
import ConstituentType from '@/constants/ConstituentType';
import AddressPropType from '@/lib/types/AddressPropType';
import DonorUserPropType from '@/lib/types/DonorUserPropType';
import DonorWorkPropType from '@/lib/types/DonorWorkPropType';
import EmailPropType from '@/lib/types/EmailPropType';
import PhonePropType from '@/lib/types/PhonePropType';
import SocialPropType from '@/lib/types/SocialPropType';

export const ConstituentCategoryPropType = PropTypes.shape({
  categoryBoardMember: PropTypes.bool,
  categoryMajor: PropTypes.bool,
  categoryMember: PropTypes.bool,
  categoryRecurring: PropTypes.bool,
  categoryVolunteer: PropTypes.bool,
});

export const ConstituentTypes = PropTypes.oneOf(values(ConstituentType));

export const ConstituentPropType = PropTypes.shape({
  avatar: PropTypes.string,
  biography: PropTypes.string,
  pronouns: PropTypes.string,
  work: PropTypes.arrayOf(PropTypes.shape(DonorWorkPropType)),
  household: PropTypes.arrayOf(PropTypes.shape(DonorUserPropType)),
  affiliations: PropTypes.arrayOf(PropTypes.shape(DonorWorkPropType)),
  connections: PropTypes.arrayOf(PropTypes.shape(DonorUserPropType)),
  summary: PropTypes.shape({
    donorType: ConstituentTypes,
    created: PropTypes.string,
    primaryEmail: PropTypes.string,
    deleted: PropTypes.bool,
    displayName: PropTypes.string,
    ownerOrgId: PropTypes.string,
    primaryPhone: PropTypes.string,
    donorId: PropTypes.string,
  }),
  lastName: PropTypes.string,
  addresses: PropTypes.arrayOf(PropTypes.shape(AddressPropType)),
  emails: PropTypes.arrayOf(PropTypes.shape(EmailPropType)),
  donorType: ConstituentTypes,
  created: PropTypes.string,
  primaryEmail: PropTypes.string,
  deleted: PropTypes.bool,
  displayName: PropTypes.string,
  phones: PropTypes.arrayOf(PropTypes.shape(PhonePropType)),
  ownerOrgId: PropTypes.string,
  updated: PropTypes.string,
  firstName: PropTypes.string,
  primaryPhone: PropTypes.string,
  note1: PropTypes.string,
  note2: PropTypes.string,
  note3: PropTypes.string,
  donorId: PropTypes.string,
  acquaintances: PropTypes.arrayOf(PropTypes.shape(DonorUserPropType)),
  contacts: PropTypes.arrayOf(PropTypes.shape(DonorUserPropType)),
  employees: PropTypes.arrayOf(PropTypes.shape(DonorUserPropType)),
  planned: PropTypes.number,
  referredBy: PropTypes.shape({
    displayName: PropTypes.string,
    userId: PropTypes.string,
  }),
  lastDonationDate: PropTypes.string,
  lifetimeCount: PropTypes.number,
  lifetimeSum: PropTypes.number,
  lastYearSum: PropTypes.number,
  thisYearCount: PropTypes.number,
  thisYearSum: PropTypes.number,
  fromN: PropTypes.number,
  toN: PropTypes.number,
  ...SocialPropType,
});

export default {
  ConstituentPropType,
  ConstituentCategoryPropType,
};
